import { Icon } from 'dyl-components';

const STEPS = [
    {
        icon: <Icon className='fas fa-cog' size='large' />, title: "Setup"
    },
    {
        icon: <Icon className='fas fa-diagram-project' size='large' />, title: "Data Mapping"
    },
    {
        icon: <Icon className='fas fa-circle-check' size='large' />, title: "Results"
    }
];

export default STEPS;